import { theme, type ThemeConfig } from "antd";

/** AntD 的种子色必须是具体色值，CSS 变量不能参与派生色运算。与 tokens.css 同步。 */
export const antdTheme: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorBgBase: "#141617",
    colorTextBase: "#f0efe8",
    colorBgContainer: "var(--bg-1)",
    colorBgElevated: "var(--bg-2)",
    colorBgLayout: "var(--bg-0)",
    colorBorder: "var(--line-2)",
    colorBorderSecondary: "var(--line-1)",
    colorText: "var(--text-1)",
    colorTextSecondary: "var(--text-2)",
    colorTextTertiary: "var(--text-3)",
    colorTextPlaceholder: "var(--text-3)",
    colorTextDisabled: "#858982",
    colorPrimary: "#d6b676",
    colorPrimaryHover: "#e5c88e",
    colorPrimaryActive: "#bea062",
    colorSuccess: "#86bc9d",
    colorWarning: "#e1ad6b",
    colorError: "#ed9386",
    colorInfo: "#d6b676",
    colorFillAlter: "var(--bg-2)",
    controlItemBgActive: "var(--accent-subtle)",
    controlOutline: "var(--accent-line)",
    fontSize: 14,
    controlHeight: 36,
    controlHeightSM: 28,
    controlHeightLG: 44,
    borderRadius: 8,
    fontFamily:
      "system-ui, -apple-system, 'PingFang SC', 'Microsoft YaHei', 'Noto Sans CJK SC', sans-serif",
    fontFamilyCode: "'JetBrains Mono', ui-monospace, Consolas, monospace",
  },
  components: {
    Button: {
      colorPrimary: "#d6b676",
      colorPrimaryHover: "#e5c88e",
      colorPrimaryActive: "#bea062",
      primaryColor: "#202218",
      primaryShadow: "none",
      defaultShadow: "none",
      dangerColor: "#202218",
      fontWeight: 500,
    },
    Switch: { colorPrimary: "#d6b676", colorPrimaryHover: "#e5c88e", handleBg: "#f0efe8" },
    Checkbox: { colorPrimary: "#d6b676", colorPrimaryHover: "#e5c88e", colorWhite: "#202218" },
    Radio: { colorPrimary: "#d6b676", colorPrimaryHover: "#e5c88e" },
    Input: { activeBorderColor: "var(--accent)", hoverBorderColor: "var(--accent-line)", activeShadow: "0 0 0 2px var(--accent-subtle)" },
    Select: { optionSelectedBg: "var(--accent-subtle)", optionSelectedColor: "var(--text-1)" },
    Segmented: { itemSelectedBg: "var(--bg-3)", itemSelectedColor: "var(--text-1)", trackBg: "var(--bg-1)" },
    Modal: { contentBg: "var(--bg-2)" },
    Drawer: { colorBgElevated: "var(--bg-1)" },
    Menu: {
      dangerItemColor: "var(--danger)",
      dangerItemHoverColor: "var(--danger)",
      dangerItemSelectedColor: "var(--danger)",
      dangerItemActiveBg: "color-mix(in srgb, var(--danger) 18%, var(--bg-2))",
      dangerItemSelectedBg: "color-mix(in srgb, var(--danger) 18%, var(--bg-2))",
    },
    Upload: { colorFillAlter: "var(--bg-2)" },
    Tabs: { itemSelectedColor: "var(--accent)" },
    Progress: { defaultColor: "var(--accent)", remainingColor: "var(--bg-3)" },
    Slider: {
      railBg: "var(--line-2)",
      railHoverBg: "var(--line-2)",
      trackBg: "var(--accent)",
      trackHoverBg: "var(--accent-hover)",
      handleColor: "var(--accent)",
      handleActiveColor: "var(--accent-hover)",
      handleActiveOutlineColor: "var(--accent-subtle)",
      handleColorDisabled: "var(--text-3)",
      trackBgDisabled: "var(--line-2)",
    },
  },
};
